export const splitArray = (array: any[], index: number): [any[], any[]] => {
  const firstPart = array.slice(0, index);
  const secondPart = array.slice(index);
  return [firstPart, secondPart];
};
